// extracted by mini-css-extract-plugin
export var actions = "_du-d";
export var benefitCard = "_du-a";
export var benefitIcon = "_du-b";
export var benefitLabel = "_du-c";
export var benefits = "_du-9";
export var bodyText = "_du-8";
export var closeButton = "_du-2";
export var content = "_du-3";
export var eyebrow = "_du-4";
export var heading = "_du-5";
export var image = "_du-f";
export var imagePanel = "_du-e";
export var modal = "_du-0";
export var shell = "_du-1";
export var title = "_du-6";
export var titleOffer = "_du-7";